import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import TableHeader from './TableHeader'
import TableLoader from './TableLoader'
import styles from './table.styl'

export default class Table extends Component {
  static propTypes = {
    children: PropTypes.any,
    loading: PropTypes.bool,
    style: PropTypes.object,
    selectable: PropTypes.bool,
    length: PropTypes.number,
    transposable: PropTypes.bool,
    ths: PropTypes.array
  }

  static defaultProps = {
    loading: false,
    length: 1,
    ths: [],
    selectable: false,
    transposable: false,
    isSingleItem: false
  }

  render() {
    const {
      children,
      loading,
      length,
      ths,
      selectable,
      style,
      transposable
    } = this.props

    const arrChildren = [].concat(children)
    let content = [].concat(children)

    if (transposable) {
      content = arrChildren.map((item, index) =>
        React.cloneElement(item, { ths, key: item.id || index })
      )

      if (content.length > 1) {
        content = <tbody>{content}</tbody>
      }
    }

    return (
      <div>
        <TableLoader loading={loading} ths={ths} />

        {!loading && (
          <div>
            <div>
              <table
                className={cx(styles.table, {
                  [styles.transposable]: transposable,
                  [styles.selectable]: selectable
                })}
                style={style}
              >
                {ths.length !== 0 && <TableHeader ths={ths} />}

                {content}
                {length === 0 && (
                  <tbody>
                    <tr>
                      <td colSpan={ths.length} className="text--center">
                        <FormattedMessage
                          id="label.no_results"
                          defaultMessage="No results"
                        />
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        )}
      </div>
    )
  }
}
